import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Alert, Badge, Button } from "@icg360/design-system";

import { useDocumentSigningUrl } from "data/ss-data-hooks";
import { trackEvent, useFlags } from "utils";

import styles from "./document-sign-row.module.scss";

const DocumentSignRow = ({ documentType, documentStatus, envelopeId }) => {
  const navigate = useNavigate();
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const { embeddedDocusign } = useFlags();
  const {
    data: signingUrlData,
    isLoading: signingUrlLoading,
    error: signingUrlError,
  } = useDocumentSigningUrl(envelopeId);
  const signingUrl = signingUrlData?.signingLink ?? "";

  const openDocusignDoc = (url) => {
    const newWin = window.open(url);
    if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
      //POPUP BLOCKED - try to open in the same tab
      const aTag = document.createElement("a");
      aTag.setAttribute("href", url);
      aTag.click();
    } else {
      newWin.focus();
    }
  };

  const linkToDocument = async () => {
    setShowErrorAlert(false);
    trackEvent(`SelfServiceCenter - Sign now clicked`, {
      status: documentStatus,
      documentType,
    });
    if (embeddedDocusign) {
      navigate(`/my/documents/sign/${envelopeId}`);
    } else {
      openDocusignDoc(signingUrl);
    }
  };

  useEffect(() => {
    if (!embeddedDocusign && signingUrlError) {
      setShowErrorAlert(true);
      trackEvent(`documents_selfServiceCenter_signError`, {
        status: documentStatus,
        error: signingUrlError,
        documentType,
      });
    }
  }, [documentStatus, documentType, embeddedDocusign, signingUrlError]);

  return (
    <>
      {showErrorAlert ? (
        <div className={styles.errorAlertWrapper}>
          <Alert
            title="Something went wrong"
            appearance="danger"
            description="Try again in a few minutes or contact customer support if the problem persists."
            onDismiss={() => setShowErrorAlert(false)}
            dismissible
          />
        </div>
      ) : null}
      <div className={styles.wrapper}>
        <div>
          <div className={styles.title}>
            <div className={styles.documentName}>{documentType}</div>
            <Badge size="compact" appearance="warning">
              Incomplete
            </Badge>
          </div>
          <div>
            Sign required documents to prevent delays in policy activation.
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            size="sm"
            onPress={linkToDocument}
            loading={!embeddedDocusign && signingUrlLoading}
            disabled={
              !embeddedDocusign && (signingUrlLoading || signingUrlError)
            }
          >
            Sign
          </Button>
        </div>
      </div>
    </>
  );
};

export { DocumentSignRow };
